// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1EsTX","boxTitle":"Qualiphy_boxTitle__3Ipg_","box":"Qualiphy_box__38UMQ","toggleWrap":"Qualiphy_toggleWrap__3LWZp"};